
import React from 'react';

export const SettingsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    settings
  </span>
);